import { createUseStyles } from "react-jss";
import { resolveChoiceIconSizeModern } from "../../theme/choiceThemeTokens";
import type { Theme } from "../../types/Theme";

export default createUseStyles({
    checkBoxIcon: {
        composes: "check-box__icon",
        verticalAlign: "middle",
        display: "inline-flex",
        alignItems: "center",
        fontSize: ({ theme }: { theme: Theme }) =>
            theme.UseModernTheme === true ? resolveChoiceIconSizeModern(theme) : 23,
        pointerEvents: "none",

        "& .custom__Image": {
            "max-height": "100%",
        },
    },
    checkBoxIconChecked: {
        composes: "check-box__icon--checked",
    },
    checkBoxIconDisabled: {
        composes: "check-box__icon--disabled",
        opacity: 0.5,
    },
});
